var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player",style:('width:' + _vm.widthHeigt[0] + 'px;' + 'height:' + _vm.widthHeigt[1] + 'px;')},[_c('div',{ref:"tcplayer",staticClass:"video",staticStyle:{"width":"402px","height":"279px"},attrs:{"id":'tcplayer' + _vm.index}})])
}
var staticRenderFns = []

export { render, staticRenderFns }